module.exports = __webpack_public_path__ + "static/media/Birthday-cake-01.632fa244.svg";